let appScript = {};

appScript = (function(){

    const reloadCaptcha = document.getElementById('captcha_code');

    const fetchData = function () {

        reloadCaptcha.innerHTML = '<img src="https://c.tenor.com/On7kvXhzml4AAAAC/loading-gif.gif" style="height: 72px;" alt="loading image">';

        fetch('/reload-captcha')
            .then(response => response.json())
            .then(data => {
                reloadCaptcha.innerHTML = data.captcha;
            });
    }

    return {
        init : function init() {
            reloadCaptcha.addEventListener('click', fetchData);
        }
    }
})();

window.addEventListener('DOMContentLoaded', (event) => {

    appScript.init();
});
